import { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import API from '../api';
import './Categoria.css';

const Categoria = () => {
  const { id } = useParams();
  const [animes, setAnimes] = useState([]);
  const [categorias, setCategorias] = useState([]);
  const [nombreCategoriaActual, setNombreCategoriaActual] = useState('Categoría');

  useEffect(() => {
    const fetchData = async () => {
      try {
        // 1. Traer tanto animes como la lista completa de categorías para la sidebar
        const [animeRes, catRes] = await Promise.all([
          API.get('/animes'),
          API.get('/categories')
        ]);

        const listaCategorias = catRes.data || [];
        setCategorias(listaCategorias);

        // 2. Encontrar el nombre de la categoría actual para el título
        const catActual = listaCategorias.find(c => c._id === id);
        if (catActual) {
          setNombreCategoriaActual(catActual.nombre);
        }

        // 3. Filtrar los animes que pertenecen a la categoría actual
        const filtrados = animeRes.data.filter(anime =>
          anime.categorias?.some(c => (c._id || c) === id)
        );
        setAnimes(filtrados);

      } catch (err) {
        console.error("Error cargando datos de categoría", err);
      }
    };

    fetchData();
  }, [id]);

  return (
    <div className="categoria-container">
      <div className="categoria-layout">
        
        {/* BARRA LATERAL: Lista de Categorías */}
        <aside className="categoria-sidebar">
          <h3 className="sidebar-title">Explorar Categorías</h3>
          <div className="sidebar-list">
            {categorias.map(cat => (
              <Link
                key={cat._id}
                to={`/categoria/${cat._id}`}
                className={`sidebar-link ${cat._id === id ? 'active' : ''}`}
              >
                <span className="sidebar-link-bullet">●</span> {cat.nombre}
              </Link>
            ))}
          </div>
        </aside>

        {/* COLUMNA PRINCIPAL: Grid de Animes */}
        <main className="categoria-main">
          <h2 className="categoria-title">
            Animes en la categoría: <span>{nombreCategoriaActual}</span>
          </h2>

          {animes.length === 0 ? (
            <p className="no-animes-msg">No se encontraron animes en esta categoría.</p>
          ) : (
            <div className="categoria-grid">
              {animes.map(a => (
                <Link
                  key={a._id}
                  to={`/anime/${a._id}`}
                  className="categoria-card"
                >
                  <div className="categoria-img-wrapper">
                    <img src={a.imagen} alt={a.titulo} />
                    {a.enEmision && <span className="badge-emision">En Emisión</span>}
                  </div>
                  <h3>{a.titulo}</h3>
                </Link>
              ))}
            </div>
          )}
        </main>

      </div>
    </div>
  );
};

export default Categoria;